import React, { useState, useContext, useCallback } from 'react'
import { useMutation } from '@tanstack/react-query'
import { AuthContext } from '@/layout/Auth'
import { UpdateUserInfo } from '@/types'
import { Footer } from './components'
import Form, { FormItem } from '@/components/Form'
import { LoadingButton } from '@/components/Button'
import { Stack, TextField } from '@mui/material'
import Text from '@/components/Text'
import { updatePassword, logout } from '@/api'
import Button from '@/components/Button'
import { Message } from '@cx/ui'

export interface InfoCardProps {
  onClose: () => void
}

const FormCard: React.FC<InfoCardProps> = (props) => {
  const { onClose } = props
  const {
    authInfo: { userInfo },
  } = useContext(AuthContext)
  const [formValue, setFormValue] = useState<UpdateUserInfo>({
    // @ts-ignore
    mail: userInfo.mail,
    old_password: '',
    new_password: '',
    confirm_password: '',
  })
  const [hasError, setHasError] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [validating, setValidation] = useState<boolean>(false)

  const logoutMutation = useMutation(logout, {
    onSuccess: () => {
      // navigate("/");
      window.open(location.href, '_self')
    },
  })

  const passwordMutation = useMutation(updatePassword, {
    onMutate: () => {
      setValidation(true)
      setLoading(true)
    },
    onSuccess: () => {
      Message.success('密码修改成功')
      setValidation(false)
      setLoading(false)
      onClose()
      logoutMutation.mutate()
    },
    onError: (error: string) => {
      setValidation(false)
      setLoading(false)
    },
  })

  const handleUpdatePassword = useCallback(() => {
    passwordMutation.mutate(formValue)
  }, [formValue, passwordMutation])

  const handleUpdateForm = useCallback((value: UpdateUserInfo) => {
    setFormValue(value)
  }, [])

  const handleUpdateError = useCallback((errorState: boolean) => {
    setHasError(errorState)
  }, [])

  return (
    <>
      <Stack sx={{ margin: '0 5%', gap: '60px', width: '30%' }}>
        <Text>账号密码</Text>
        <Form
          initialValue={formValue}
          // @ts-ignore
          onFormValueChange={handleUpdateForm}
          // @ts-ignore
          onValidate={handleUpdateError}
          validating={validating}
        >
          <FormItem
            label='old_password'
            text='旧密码'
            rules={{
              errorMessage: '密码不能为空且限长32',
              validator: (value: string) => value?.length > 0 && value?.length <= 32,
            }}
          >
            <TextField placeholder={'请输入旧密码'} fullWidth={true} type='password' />
          </FormItem>
          <FormItem
            label='new_password'
            text='新密码'
            rules={{
              errorMessage: '密码不能为空且限长32',
              validator: (value: string) => value?.length > 0 && value?.length <= 32,
            }}
          >
            <TextField placeholder={'请输入新密码'} fullWidth={true} type='password' />
          </FormItem>
          <FormItem
            label='confirm_password'
            text='确认密码'
            rules={{
              errorMessage: '与新密码不相同',
              validator: (value: string) => value === formValue.new_password,
            }}
          >
            <TextField placeholder={'请确认密码'} fullWidth={true} type='password' />
          </FormItem>
        </Form>
        <Footer>
          <LoadingButton disabled={hasError} loading={loading} onClick={handleUpdatePassword}>
            保存
          </LoadingButton>
          <Button type='text' onClick={onClose}>
            取消
          </Button>
        </Footer>
      </Stack>
    </>
  )
}

export default FormCard
